<template>
  <div style="background: url('../../static/img/login-bg.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;"
  class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="7">
          <b-card-group class="login-modal-card-group" no-border>
            <b-card @keyup.enter="onSubmit" no-body class="login-modal-card">
              <b-card-body>
                <img src="/static/img/new-logo.png" height="40" width="130">
                <div class="login-modal-title-wrapper">
                  <h2 class="login-modal-title login-modal-title--bold">Lighthouse</h2>
                  <div class="login-modal-divider"></div>
                  <div class="login-modal-title login-modal-title--subtle">
                    Screening
                  </div>
                </div>
                <p class="login-modal-text">Enter your credentials below to sign in.</p>
                <b-form @submit.stop.prevent="onSubmit">
                  <b-input-group class="login-modal-form-input">
                    <input type="text" autocomplete="username" class="form-control" name="email" v-model="email" v-validate="'required|email'" data-vv-delay="500" placeholder="Email">
                  </b-input-group>
                  <b-input-group class="login-modal-form-input">
                    <input type="password" autocomplete="current-password" class="form-control" name="password" v-validate="'required'" v-model="password" data-vv-delay="500" placeholder="Password">
                  </b-input-group>

                  <div class="login-modal-btn-group">
                    <a href="https://share.hsforms.com/14nS3iVw0T06rPCSl5vRLew2gbug?lighthouse_access=User" target="_blank" class="px-0 login-modal-text login-modal-link">
                      Get Access
                    </a>
                    <b-button router-link :to="'/pages/forgotpassword'" variant="link" class="px-0 login-modal-text login-modal-link">
                      Forgot password
                    </b-button>
                  </div>

                  <div class="login-modal-footer">
                    <b-button :disabled="timeout > 0" type="submit" variant="primary" class="px-4 login-modal-btn">
                      Login
                    </b-button>
                  </div>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  computed: {
    loginApiError () {
      return this.$store.getters.getLoginApiError
    }
  },
  watch: {
    loginApiError (newValue) {
      if (newValue) {
        this.$store.commit('resetLoginApiError')
        clearTimeout(this.clearLockTimeout)
        if (newValue.code === 'login_locked_out') {
          const lockTimeLeftInMins = Math.round(Math.ceil(newValue.lockTimeLeft / 1000 / 60))
          const unit = lockTimeLeftInMins === 1 ? 'minute' : 'minutes'
          window.alert(`Please try again after ${lockTimeLeftInMins} ${unit}.`)
          this.timeout = newValue.lockTimeLeft
          this.clearLockTimeout = setTimeout(() => {
            this.timeout = 0
          }, newValue.lockTimeLeft)
        } else {
          window.alert(newValue.message)
        }
      }
    }
  },
  data () {
    return {
      dictionary: {
        custom: {
          loginemail: {
            required: () => 'Please enter the Email field.',
            email: () => 'Please enter a valid Email Id'
          },
          password: {
            required: () => 'Please enter the Password field.'
          }
        }
      },
      title: 'Welcome - Please Login',
      email: '',
      password: '',
      error: '',
      timeout: 0
    }
  },
  methods: {
    onSubmit () {
      this.$validator.validate().then(result => {
        if (!result) {
          window.alert('Please contact lighthouse@alliesagainstslavery.org for help logging in.')
          return
        }
        // if all fields are valid submit the request
        let params = {
          'email': this.email,
          'password': this.password
        }

        this.$auth.login({
          body: params,
          rememberMe: true
        }).then((response) => {
          // Success handler
        }, (response) => {
          // Error handler
        })
      })
    }
  },
  mounted () {
  },
  created () {
    this.$validator.localize('en', this.dictionary)
  },
  beforeDestroy () {
    clearTimeout(this.clearLockTimeout)
  }
}
</script>


// WEBPACK FOOTER //
// src/views/pages/Login.vue